import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  gridItem: {
    [Theme.breakpoints.up('xs')]: {
      padding: '17px 10px 17px 10px !important',
    },
    [Theme.breakpoints.up('sm')]: {
      padding: '17px 10px 17px 10px !important',
    },
    [Theme.breakpoints.up('md')]: {
      padding: '20px 10px 20px 10px !important',
    },
    [Theme.breakpoints.up('lg')]: {
      padding: '20px 15px 20px 15px !important',
    },
  },
}));

export default useStyles;
